import { ReferralStatus } from '../../../models/graphqlTypes'

export interface PatientReferralsFilter {
  isValid?: boolean
  isExpired?: boolean
}

const validStatuses = [ReferralStatus.Created, ReferralStatus.AppointmentBooked]
const expiredStatuses = [
  ReferralStatus.Expired,
  ReferralStatus.Finished,
  ReferralStatus.WaitingOnResult,
]

export const getStatusesByReferralStatusFilter = (
  filter: PatientReferralsFilter
): ReferralStatus[] => {
  const statuses: ReferralStatus[] = []
  if (filter.isValid) {
    statuses.push(...validStatuses)
  }
  if (filter.isExpired) {
    statuses.push(...expiredStatuses)
  }
  return statuses
}

export const isReferralExpired = (referralStatus: ReferralStatus) =>
  [...expiredStatuses, ReferralStatus.Deleted].includes(referralStatus)
